import { createRootRoute, Outlet, redirect } from "@tanstack/react-router";

// Thin root shell — no auth guard, no layout chrome.
// Auth routes (/auth/*) render their own layout via routes/auth/route.tsx.
// Protected routes render the app shell via routes/_protected/route.tsx.
// The OAuth callback always lands at / (routes/index.tsx) before any layout runs.
export const Route = createRootRoute({
  beforeLoad: () => {
    // Support hash-style navigation (e.g. /#/settings → /settings).
    const hash = window.location.hash;
    if (hash.startsWith("#/") && hash.length > 2) {
      throw redirect({ to: hash.slice(1) as string, replace: true });
    }
  },
  component: () => <Outlet />,
});
